<template>
	<div class="main">
		<div class="gallery">
			<router-link
				tag="div"
				:to="`stories/${post.id}`"
				class="img"
				:class="{ highlight: post.type === 'story' }"
				v-for="(post, index) in posts"
				:key="index"

			>
				<template v-if="post.type === 'story'">
					<div class="story-thumbnail">
						<img :src="post.thumbnailUrl" />
					</div>
					<div class="story-detail">
						<div class="description" v-html="post.shortContent"></div>
						<div class="author" v-if="post.author">
							<div class="profile-picture">
								<img :src="post.author.picture" />
							</div>
							<div class="author-detail">
								<div class="author-name">{{ post.author.screenName }}</div>
								<div class="author-short-bio">{{ post.author.shortBio }}</div>
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="moment-thumbnail">
						<img :src="post.thumbnail.url" />
					</div>
				</template>
			</router-link>
		</div>
		
		<router-view :posts="posts" v-if="posts.length > 0"></router-view>
	</div>
</template>

<script>
import _ from 'lodash';
import striptags from 'striptags';
import truncate from 'truncate';
import porfile from '@/assets/images/profile.png';
import ButtonS from '@/assets/images/button-s.png';
import close from '@/assets/images/close.png';
export default {
	name: 'Home',
	data() {
		return {
			next: null,
			nextToken: null,
			porfile: porfile,
			ButtonS: ButtonS,
			close: close,
			showDetailPopup: false,
			selectedPost: null,
			selectedStory: null,
			connectedPosts: [],
			posts: [],
			storyStore: [],
			moment: {
				posts: [],
				next: null,
				hasNext: true,
				limit: 40,
			},
			story: {
				posts: [],
				page: 1,
				final: false,
				limit: 10,
			},
		};
	},
	async mounted() {
		this.loadAll();
		this.setupScrollingEvent();
	},
	destroyed() {
		this.removeScrollingEvent();
	},
	methods: {
		async loadAll() {
			const lastIndex = this.posts.length;
			const moments = await this.loadMoments();
			const rawStories = await this.loadStory();

			moments.forEach((it) => (it.type = 'moment'));
			rawStories.forEach((it) => {
				it.type = 'story';
				it.shortContent = truncate(striptags(it.content), 250);
			});

			const stories = _.shuffle(rawStories);
			this.storyStore = [...this.storyStore, ...stories];

			const posts = [...this.posts, ...moments];

			for (let i = 0, n = posts.length; i < n; i++) {
				if (this.storyStore.length < 1) break;

				const mod = (i + 1) % 18;
				if (mod === 1 || mod === 14) {
					const story = this.storyStore.shift();
					posts.splice(i, 0, story);
				}
			}

			this.posts = posts;
		},
		async loadStory() {
			if (this.story.final) return [];

			const data = await this.$repo.story.getStories(this.story.limit, this.story.page);
			this.story.final = data.final;
			return data.data;
		},
		async loadMoments() {
			if (!this.moment.hasNext) return [];

			const data = await this.$repo.moment.getMoments(this.moment.limit, this.moment.next);
			this.moment.next = data.next;
			return data.results;
		},
		onClickPost(post) {
			this.selectedPost = post;
			this.showDetailPopup = true;
		},
		onClickShare() {
			if (!this.selectedPost) return;

			const url = `${window.location.protocol}//${window.location.hostname}?open=${this.selectedPost.id}`;
			const title =
				this.selectedPost.type === 'story'
					? this.selectedPost.title
					: truncate(striptags(this.selectedPost.content), 100);
			const text = truncate(striptags(this.selectedPost.content), 200);

			if (navigator.share) {
				navigator.share({
					title,
					text,
					url,
				});
			} else {
				
			}
		},
		detectScrolling() {
			console.log(window);
		},
		setupScrollingEvent() {
			//window.addEventListener('scroll', this.detectScrolling);
		},
		removeScrollingEvent() {
			//window.removeEventListener('scroll', this.detectScrolling);
		},
	},
};
</script>

<style lang="scss">
.main {
	position: relative;
	height: 100%;
	width: 100%;
	// overflow: hidden;

	.gallery {
		position: relative;
		height: auto;
		width: 100%;
		margin: auto;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-auto-rows: 1fr;
		grid-gap: 1px;

		.img {
			cursor: pointer;
			overflow: hidden;

			&.highlight {
				padding-bottom: 0;
				height: auto;
				grid-column-end: span 2;
				grid-row-end: span 4;
				display: flex;
				flex-direction: column;
			}

			.story-thumbnail {
				width: 100%;
				height: 50%;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			.story-detail {
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding: 30px;

				.description {
					margin-bottom: 30px;
				}

				.author {
					display: flex;
					box-sizing: border-box;
				}

				.author-name {
					font-size: 28px;
					font-weight: bold;
				}

				.author-short-bio {
					font-size: 17px;
				}

				.profile-picture {
					width: 80px;
					height: 80px;
					border-radius: 50%;
					overflow: hidden;
					margin-right: 10px;
					flex: 0 0 auto;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
			}

			.moment-thumbnail {
				width: 100%;
				height: 100%;
				position: relative;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
				}
			}
		}

		.detail-popup {
			position: relative;
			display: none;
			height: 100%;
			width: 50%;
			padding: 30px;

			.profile {
				position: absolute;
				bottom: 10px;
				.pic-profile {
					display: flex;

					img {
						max-width: 71px;
						width: 100%;
					}

					.list-detail {
						list-style: none;
						padding: 0 10px;

						li {
							&:first-child {
								font-size: 18px;
								font-weight: bold;
							}

							&:last-child {
								padding-top: 40px;
								font-size: 18px;
								font-weight: bold;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		.gallery {
			grid-template-columns: repeat(8, 1fr);

			.img {
				&.highlight {
					grid-column-end: span 4;
					grid-row-end: span 2;
					padding-bottom: 0;
					flex-direction: row;
					align-items: center;
				}

				.story-thumbnail,
				.story-detail {
					width: 50%;
					height: 100%;
				}

				.story-detail {
					padding: 0 30px;
					justify-content: center;
				}
			}
		}
	}
}

.modal-body {
	.profile {
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.profile-picture {
		width: 70px;
		height: 70px;
		border-radius: 50%;
		overflow: hidden;
		flex: 0 0 auto;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.list-detail {
		padding: 0;
		list-style: none;
		flex: 1 1 auto;
		margin-left: 20px;
	}

	.description {
		margin-top: 20px;
		font-size: 14px;
	}

	.network-icon {
		margin-top: 10px;
		margin-right: 20px;
		font-size: 1.8rem;
	}

	.action-buttons {
		margin-top: 20px;
		margin-left: -6px;
	}

	.btn-find {
		height: 40px;
		background-color: #da006a;
		color: #fff;
		border-radius: 20px;

		&:hover {
			color: #fff;
		}
	}

	.share-button {
		cursor: pointer;
	}

	.misc {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	@media screen and (min-width: 992px) {
		.profile {
			margin-top: 0;
		}

		.moment .btn-find {
			position: absolute;
			bottom: -20px;
			right: 20px;
		}

		.story .btn-find {
			text-align: right;
		}

		.network-icon {
			margin-right: 0;
		}

		.misc {
			flex-direction: column;
			align-items: flex-start;
		}
	}
}
</style>
